<template>
  <content-section
    title="Check-in Automatico"
    :background_color="sass('selected')"
    :description="`Se scegli questo servizio saremo noi ad effettuare il check-in per te e ad inviarti via email le carte di imbarco. Approfittane: il servizio è comodo${has_price ? ' e sicuro.' : ', sicuro e offerto gratuitamente.'}`"
  >
    <div class="automated-check-in">
      <div class="automated-check-in__row">
        <div class="automated-check-in__select">
          <vb-checkbox
            :vb_options="{
              checked: selected,
              switch: true,
              type: 'light',
              text: has_price
                ? 'Attiva check-in automatico'
                : 'Attiva check-in automatico gratuito',
            }"
            @change="on_select"
          />
          <span v-if="has_price" class="automated-check-in__price">{{
            display_price
          }}</span>
        </div>
        <span
          v-for="(line, index) in tag_lines"
          :key="`tag-line:${index}`"
          class="automated-check-in__tag-line"
        >
          <vb-icon name="check_circle" :size="12" :color="sass('success')" />
          <span>{{ line }}</span>
        </span>
      </div>
      <div>
        <div class="automated-check-in__row-line">
          <vb-icon name="info" :size="12" color="AAA" /> Condizioni principali:
        </div>
        <div>
          Potremmo richiederti via email dati o documenti aggiuntivi. Resta tua
          responsabilità verificare correttezza dei dati e validità dei
          documenti. Se il check-in automatico non andasse a buon fine, ti
          avviseremo in tempo utile per procedere autonomamente.
        </div>
      </div>

      <div class="automated-check-in__row-line">
        Se scegli questo servizio accetti le
        <button
          v-b-modal="'terms-and-conditions'"
          role="button"
          type="button"
          class="automated-check-in__terms-and-conditions"
        >
          Condizioni d’uso.
        </button>
      </div>
      <vb-modal
        :vb_options="{
          id: 'terms-and-conditions',
          title: 'Condizioni d’uso del check-in automatico',
          ok_only: true,
          hide_footer: true,
          centered: true,
          size: 'lg',
        }"
      >
        <p v-if="has_price">
          Il servizio ci consente di effettuare il check-in online per tuo conto
          e inviarti le carte di imbarco via email.
        </p>
        <p v-else>
          Il servizio è gratuito e ci consente di effettuare il check-in online
          per tuo conto e inviarti le carte di imbarco via email.
        </p>
        <hr />
        <terms-and-conditions />
      </vb-modal>
    </div>
  </content-section>
</template>

<script>
  import { is_set } from '@/utilities';
  import { formatPrice } from '@liveflight/utilities/mixins';
  import ContentSection from '@liveflight/components/blocks/wrappers/content-section.vue';
  import TermsAndConditions from '@liveflight/components/blocks/check-in/terms-and-conditions.vue';

  export default {
    name: 'automated-check-in',
    components: {
      'content-section': ContentSection,
      'terms-and-conditions': TermsAndConditions,
    },
    props: {
      selected: { type: Boolean, default: false },
      price: { type: Object, default: () => undefined },
    },
    data() {
      return {
        tag_lines: [
          'Non dovrai ricordarti del check-in online né farlo tu sul sito della compagnia aerea.',
          "Riceverai le carte di imbarco via email e, quando previsto, anche sull'app della compagnia aerea.",
        ],
      };
    },
    computed: {
      /**
       * The backend's own formatting wins: when it ships a `display` we render
       * it verbatim rather than reformatting the amount, so the panel can never
       * disagree with the server about how the fee looks.
       */
      display_price() {
        if (!is_set(this.price)) {
          return '';
        }
        const {
          grandTotal = '',
          total = '',
          display = '',
          currencySymbol = '',
        } = this.price;
        if (display) {
          return display;
        }
        const amount = grandTotal === '' ? total : grandTotal;
        if (!Number(amount)) {
          return '';
        }
        return `${formatPrice(amount)} ${currencySymbol}`.trim();
      },
      has_price() {
        return !!this.display_price;
      },
    },
    methods: {
      // Never gated on `value`: the opt-outs are the point.
      on_select(value) {
        this.track_form({
          event: `automated-checkin:choice:${value ? 'add' : 'remove'}`,
          data: { type: 'info' },
        });
        this.$emit('select', value);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .automated-check-in {
    display: flex;
    flex-direction: column;
    gap: 16px;
    font-size: 14px;

    &__select {
      display: flex;
      gap: $grid-gutter-width / 6;
      align-items: center;
    }

    &__row {
      display: flex;
      flex-direction: column;
      gap: 5px;
      &-line {
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }

    &__tag-line {
      display: flex;
      align-items: center;
      gap: 5px;
      margin-left: $grid-gutter-width * 1.5;
    }

    // Same treatment as ancillary-option__price, anchored bottom-left of the
    // panel: the fee reads as one of the extras the customer is picking.
    &__price {
      align-self: flex-start;
      margin-top: auto;
      font-weight: $vb-font-weight-semibold;
      color: $primary;
      font-size: $font-size-md;
      white-space: nowrap;
    }

    &__terms-and-conditions {
      border: none;
      padding: 0px;
      margin: 0px;
      background-color: transparent;
      color: var(--info);
      text-decoration: underline;
    }
  }
</style>
